export const DASHBOARD_EFFECTIVE_TARGETS_QUERY_KEY = 'dashboardEffectiveTargets'
export const DASHBOARD_LIGHT_SCHEDULES_QUERY_KEY = 'dashboardLightSchedules'
